import { combineReducers } from 'redux'

import * as h2Api from '../../h2Api'
import { SD_RESULTS } from '../../actions/assessments/skillsProfiler'

export default combineReducers({
  results: h2Api.restReducer(SD_RESULTS)
})
